/*
 * Homepage category rail — Swiper grab/drag (Windsor multicolumn pattern).
 * Desktop grid is a separate tree; this only mounts on [data-ph-category-swiper].
 * IIFE avoids const/function collisions with ph-collection-swiper.js.
 */
(() => {
  const INSTANCE_KEY = '_phCategorySwiper';
  const LISTENER_KEY = '__phCategorySwiperBound';
  /* The static desktop row only reaches Figma's 316px card at ~1440. At 990 it
     produced 165px cards, a 37% drop from the 260px the rail was showing one
     pixel earlier. Switching at 1280 instead means the first static row starts
     at ~257px, so the rail hands over at the width it was already showing. */
  const MQ = '(max-width: 1279px)';

  function swiperOptions() {
    return {
      slidesPerView: 'auto',
      spaceBetween: 15,
      slidesOffsetAfter: 15,
      grabCursor: true,
      simulateTouch: true,
      allowTouchMove: true,
      watchOverflow: true,
      resistanceRatio: 0.85,
      observer: true,
      observeParents: true,
      breakpoints: {
        750: {
          spaceBetween: 15,
          slidesOffsetAfter: 50,
        },
      },
    };
  }

  function destroyRoot(root) {
    if (root[INSTANCE_KEY]) {
      root[INSTANCE_KEY].destroy(true, true);
      root[INSTANCE_KEY] = null;
    }
  }

  function initRoot(root) {
    if (!window.Swiper) return;
    const el = root.querySelector('.swiper');
    if (!el) return;
    destroyRoot(root);
    if (!window.matchMedia(MQ).matches) return;
    root[INSTANCE_KEY] = new window.Swiper(el, swiperOptions());
  }

  function initAll(scope) {
    scope.querySelectorAll('[data-ph-category-swiper]').forEach(initRoot);
  }

  function destroyAll(scope) {
    scope.querySelectorAll('[data-ph-category-swiper]').forEach(destroyRoot);
  }

  function boot() {
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  if (!window[LISTENER_KEY]) {
    window[LISTENER_KEY] = true;

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target instanceof Element) initAll(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target instanceof Element) destroyAll(event.target);
    });

    window.matchMedia(MQ).addEventListener('change', () => {
      initAll(document);
    });
  }
})();
